import React, { useState } from "react";

import AlertTable from "./EventsTable";

import { Card, CardBody, CardHeader } from "reactstrap";
// import RangePicker_Table from "./RangePicker";
import useFetch from "../../Controllers/useFetch";
import Loader from "../../Loader";
import { Divider, Tabs, Typography } from "antd";
import { gql, useQuery } from "@apollo/client";
import RangePickerEvents from "./RangePicker";
import { useSelector } from "react-redux";
import moment from "moment-jalaali";

const { Text, Paragraph } = Typography;

const GET_PLANT_EVENTS = gql`
  query events($plant_id: Int!, $dates: [Date], $offset_date: Int, $skip: Int) {
    GetSystemsEvents(
      plant_id: $plant_id
      dates: $dates
      skip: $skip
      offset_date: $offset_date
    ) {
      gateway_Event {
        event_time
        event_code
        description
        Event_Description {
          title
          content
        }
        plant_id
        Gateway_id
        Gateway_Devices {
          serial_number
        }
      }
      po_Event {
        event_time
        event_code
        description
        Event_Description {
          title
          content
        }
        plant_id
        PO_id
        Power_Optimizer {
          serial_number
        }
      }
      gateway_count
      po_count
    }
  }
`;

const initialDate = new Date();

const EventsPage = () => {
  const lang_choiced = useSelector((state) => state.lang_change);

  const [dateHOC, setDateHOC] = useState([
    moment(initialDate).format("jYYYY-jMM-jDD"),
    moment(initialDate).format("jYYYY-jMM-jDD"),
  ]);
  const [newData, setData] = useState([]);

  console.log([moment(dateHOC[0], "jYYYY-jMM-jDD").format("YYYY-MM-DD"),
  moment(dateHOC[1], "jYYYY-jMM-jDD").format("YYYY-MM-DD"), dateHOC],
  )
  const plant_id = parseInt(window.location.hash.split("/")[1]);

  const { data, loading, refetch } = useQuery(GET_PLANT_EVENTS, {
    variables: {
      plant_id,
      dates: [moment(dateHOC[0], "jYYYY-jMM-jDD").format("YYYY-MM-DD"),
      moment(dateHOC[1], "jYYYY-jMM-jDD").format("YYYY-MM-DD"),],
      offset_date: new Date().getTimezoneOffset(),
      skip: 0,
    },
    onCompleted: (res) => {
      console.log(res);
    },
    onError: (err) => {
      console.log(err);
    },
  });

  // console.log(data, "is data events");

  if (loading === true) {
    return <Loader />;
  } else {
    return (
      <div className="animated fadeIn">
        {
          // <Card>
          //   <CardBody>
          //     <div className="text-center mb-4">
          //       <RangePicker_Table newDate={handleDateChange} newData={handleDataChange}/>
          //     </div>
          //     </CardBody>
          //   </Card>
        }
        <Card>
          <CardHeader>
            <h3>{lang_choiced.pages.events.title}</h3>
          </CardHeader>
          <CardBody>
            <Paragraph>
              <Text type="success">{lang_choiced.pages.events.tip}</Text>
              <Text>
                {lang_choiced.pages.events.tipText}
              </Text>
            </Paragraph>
            <Divider />
            <div className="text-center mb-4">
              <RangePickerEvents
                dateHOC={dateHOC}

                setDatesHOC={(date) => {
                  // console.log(date, "is new date"); // ['1404-07-03', '1404-07-03']

                  // // // تاریخ اول به میلادی
                  // const start = date[0]
                  // // // start.setUTCHours(0, 0, 0, 0);  // شروع روز UTC

                  // // // تاریخ دوم به میلادی
                  // const end = date[1]
                  // // // end.setUTCHours(23, 59, 59, 999); // پایان روز UTC

                  // console.log([start.toISOString(), end.toISOString()], "is send data");

                  setDateHOC(date);

                  refetch({
                    plant_id,
                    skip: 0,
                    dates: [moment(date[0], "jYYYY-jMM-jDD").format("YYYY-MM-DD"),
                    moment(date[1], "jYYYY-jMM-jDD").format("YYYY-MM-DD"),],
                    offset_date: new Date().getTimezoneOffset(),
                  });
                }}
              />
            </div>
            <Tabs
              className="ltr"
              defaultActiveKey="1"
              items={[
                {
                  label: "String Manager",
                  key: 1,
                  className: "rtl",
                  children: (
                    <AlertTable
                      data={data?.GetSystemsEvents.gateway_Event || []}
                      EventsPage={true}
                      total={data?.GetSystemsEvents.gateway_count || []}
                      date={dateHOC}
                      refetch={({ skip }) =>
                        refetch({
                          plant_id,
                          skip,
                          dates: dateHOC,
                          offset_date: new Date().getTimezoneOffset(),
                        })
                      }
                      loading={loading}
                    />
                  ),
                },
                {
                  label: "UPV",
                  key: 2,
                  className: "rtl",
                  children: (
                    <AlertTable
                      data={data?.GetSystemsEvents.po_Event || []}
                      EventsPage={true}
                      total={data?.GetSystemsEvents.po_count || []}
                      date={dateHOC}
                      refetch={({ skip }) =>
                        refetch({
                          plant_id,
                          skip,
                          dates: dateHOC,
                          offset_date: new Date().getTimezoneOffset(),
                        })
                      }
                      loading={loading}
                    />
                  ),
                },
              ]}
            />
            {/* <Divider>
              <h2>رویداد های String ها</h2>
            </Divider>

            <Divider>
              <h2>رویداد های Optimizer ها</h2>
            </Divider> */}
          </CardBody>
        </Card>
      </div>
    );
  }
};

export default EventsPage;
